import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

const Notification = props => {
  const { errorMessage, show, hideError, t } = props;

  return (
    <div
      className={`notificationContainer ${
        show ? 'showNotification' : 'hidden'
      } ${errorMessage ? 'hasMessage' : ''}`}
    >
      <div className="notificationText">
        {t(errorMessage) || t('Something went wrong.')}
      </div>
      <div className="notificationClose">
        <img
          src="/content/images/icons/icon-close-white.svg"
          alt=""
          className="closeIcon"
          onClick={hideError}
          aria-hidden="true"
        />
      </div>
    </div>
  );
};

Notification.propTypes = {
  show: PropTypes.bool,
  hideError: PropTypes.func,
  errorMessage: PropTypes.string
};

Notification.defaultProps = {
  show: false,
  hideError: () => {},
  errorMessage: ''
};

export default withTranslation()(Notification);
